module.exports = __webpack_public_path__ + "img/20260309_1.08acb0c6.jpg";